<template>
  <v-container fluid class="grey lighten-5">
    <div class="my-3">
      <v-btn icon :to="returnPath">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 px-3">お見積依頼の確認</span>
    </div>

    <v-row dense>
      <v-col :cols=12 transition="scroll-y-transition">
        <v-card outlined flat class="pa-0">
<!--
          <v-card-title class="ma-0 pb-0">お見積り内容</v-card-title>
-->
          <v-toolbar dense flat class="black--text ma-0 pl-2 py-0" color="grey lighten-1">お見積り内容
            <v-spacer></v-spacer>
            <v-chip small label color="grey lighten-2" class="label-chip px-2 ml-2">サンプル数</v-chip>{{selectedSamples.length}}
            <v-chip small label color="grey lighten-2" class="label-chip px-2 ml-2">見積相談</v-chip><div v-if="this.$store.state.isStaff">{{AnsweredCount}}/</div>{{OpinionCount}}
            <v-chip small label color="grey lighten-2" class="label-chip px-2 ml-2">サンプル返却</v-chip>{{SurplusCount}}
          </v-toolbar>

          <div class="mt-5">
            <v-chip v-bind="getApplicationStatus(this.quote.Status,applicationStatusMode)" class="ml-4 mb-3">{{getApplicationStatus(this.quote.Status, applicationStatusMode).text}}</v-chip><span class="subtitle-1 ml-5 ">{{getApplicationStatus(this.quote.Status, applicationStatusMode).message}}</span><br>
            <v-chip small label color="grey darken-2" class="label-chip white--text px-2 ml-5">ご担当者様</v-chip><span class="subtitle-1 mt-5 ">{{ OrdererName }} 様</span><br>
            <v-chip small label color="grey darken-2" class="label-chip white--text px-2 ml-5">案件名</v-chip><span class="subtitle-1 mt-5 ">{{ ApplicationName }}</span><br>
            <v-chip small label color="grey darken-2" class="label-chip white--text px-2 ml-5">分析料金合計</v-chip><span class="subtitle-1 mt-5 ">{{ TotalFee.toLocaleString() }} 円（税抜き）</span><span v-if="SurplusCount > 0" class="ml-1 mt-5 subtitle-2">（サンプル返却手数料含む）</span>
            <template v-if="DiscountInfo.code">
            <br><v-chip small label color="grey darken-2" class="label-chip white--text px-2 ml-5">Web割引</v-chip><span class="subtitle-1 mt-5 ">- {{Number(DiscountInfo.discount).toLocaleString()}} 円</span>
            </template>

          </div>
          <v-list class="cart-list mt-0" style="" dense nav>
            <template v-for="(item, index) in selectedSamples">
              <v-list-item
                :key="index"
                v-show="isShowCart"
              >
                <v-list-item-content class="body-2">
                    <v-card outlined flat class="pa-0">
<!--
                      <v-chip v-if="item.id==editid" label outlined color="blue" class="white--text mt-2 ml-2">編 集 中</v-chip>
                      <v-chip v-if="item.id==viewid" label outlined color="green" class="white--text mt-2 ml-2">参 照 中</v-chip>
                      <v-chip v-if="item.delete" label color="red" class="white--text mt-2 ml-2">削除されました</v-chip>
                      <v-chip v-if="item.update" label color="blue" class="white--text mt-2 ml-2">変更されました</v-chip>
                      <v-chip v-if="item.insert" label color="green" class="white--text mt-2 ml-2">追加されました</v-chip>
-->
                      <v-app-bar
                        flat
                        color="rgba(0, 0, 0, 0)"
                        class="ma-0 pa-0"
                        max-height="32px"
                      >
                        <v-toolbar-title class="text-h6 black--text pl-0 mt-0">
                          <v-chip v-if="item.OilTypeCategoryText=='潤滑油'" small color="green" class="white--text mr-2">{{ item.OilTypeCategoryText }}</v-chip>
                          <v-chip v-else-if="item.OilTypeCategoryText=='燃料'" small color="yellow" class="black--text mr-2">{{ item.OilTypeCategoryText }}</v-chip>
                          <v-chip v-else-if="item.OilTypeCategoryText=='グリス'" small color="blue" class="black--text mr-2">{{ item.OilTypeCategoryText }}</v-chip>
                          {{ item.Name }}
                        </v-toolbar-title>
<!--
                        <v-spacer></v-spacer>
                        <v-tooltip top color="grey" v-if="!getSampleButtonDisabled(item).check">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).check"
                              @click="viewSample(item)">
                              <v-icon >mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>サンプルの内容をみます</span>
                        </v-tooltip>


                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).edit"
                              @click="editSample(item)">
                              <v-icon >mdi-lead-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>サンプルを編集します</span>
                        </v-tooltip>

                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).copy"
                              @click="copySample(item)">
                              <v-icon >mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <span>サンプルをコピーします</span>
                        </v-tooltip>

                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).delete"
                              @click="delSample(item)">
                              <v-icon >mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>サンプルを削除します</span>
                        </v-tooltip>
-->
                      </v-app-bar>
                      <v-card-subtitle class="pb-1">
                        <v-chip v-if="item.isHazardousMaterials == 1" x-small color="red" class="white--text ml-2">取扱注意</v-chip>
                        {{ item.OilTypeText }}
                      </v-card-subtitle>
                      <v-card-title class="pt-0 pb-0 mb-0">
                        <v-chip small label color="gray" class="label-chip">分析セット</v-chip><div class="mr-2">{{ item.AnalizeTypeGroupName }}</div> <div v-if="item.AnalizeSet">{{ item.AnalizeSetName }}</div><div v-else>（分析セット指定なし）</div>
                      </v-card-title>
                      <v-card-title class="pt-0 pb-0 mb-0">
                        <v-chip small label color="gray" class="label-chip">サンプル数</v-chip><div>{{ item.SameCount }} サンプル</div>
                      </v-card-title>
                      <v-card-title class="pt-0 pb-0 mb-0">
                        <v-chip small label color="gray" class="label-chip">分析料金</v-chip><div>{{ (Number(item.Fee) * Number(item.SameCount)).toLocaleString() }} 円（税抜き）</div>
                      </v-card-title>

<!--
                              v-model="item.AnalizeItemsInclude"
                              :items="item.analizeItemListInclude"
-->
                      <v-card-text class="mb-0">
                        <v-row v-if="item.AnalizeSet" class="mb-0" dense>
                          <v-col cols="12" md="12" dense>
                            <v-select
                              v-model="analizeSetItems"
                              :items="analizeSetItems"
                              item-value="Value"
                              item-text="Text"
                              label="次の分析項目がセットに含まれます"
                              multiple
                              readonly
                              class="mt-2 pb-0"
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip small color="gray">
                                  <span>{{ item.Text }}</span>
                                </v-chip>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
<!--
                        <v-row v-if="item.AnalizeItems.length>0" dense>
                          <v-col cols="12" md="12" dense>
                                <v-select
                                  v-model="item.AnalizeItems"
                                  :items="item.analizeItemList"
                                  item-value="Value"
                                  item-text="Text"
                                  label="次の分析項目が選択されています"
                                  multiple
                                  readonly
                                  class="mt-0 black--text"
                                >
                                  <template v-slot:selection="{ item }">
                                    <v-chip
                                      small
                                      color="green darken-3"
                                      text-color="white"
                                    >
                                      <span>{{ item.Text }}</span>
                                    </v-chip>
                                  </template>
                                </v-select>
                          </v-col>
                        </v-row>
-->
                        <template v-if="item.allAnalizeItemNames">
                          <v-row dense>
                            <v-col cols="12" md="12" dense>
                              <div class="caption mt-0">次の分析項目が選択されています</div>
                              <template v-for="(item, index) in item.allAnalizeItemNames">
                                <v-chip small color="green darken-3" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                              </template>
                            </v-col>
                          </v-row>
                        </template>

                        <v-row dense>
                          <v-col cols=12 dense>
                            <v-chip small label color="gray" class="label-chip">オプション</v-chip>
                            <v-chip v-if="item.Opinion==true" small label color="red" class="white--text ml-0 mr-2 mb-1">{{ getOpinionString(item.Opinion )}}</v-chip>
                            <v-chip v-if="item.Filter!='001'" small outlined label color="green darken-3" class="mr-2 mb-1">{{ getFilterString(item.Filter) }}</v-chip>

                            <v-chip v-if="item.Surplus!='0'"  small outlined label color="green darken-3" class="mr-2 mb-1">{{ getSurplusString(item.Surplus) }}</v-chip>
                          </v-col>
                        </v-row>

                        <v-card-subtitle v-if="item.Memo" class="mt-3 mb-0 pa-0">分析・診断依頼についてのご相談内容</v-card-subtitle>
                        <v-card v-if="item.Memo" flat class="mt-0 pa-1">
                          <strong style="white-space:pre-wrap; word-wrap:break-word;">
                            {{item.Memo}}
                          </strong>
                        </v-card>
                        <v-card-subtitle v-if="item.Message" class="mt-3 mb-0 pa-0">ジャパン・アナリストからの回答</v-card-subtitle>
                        <v-card v-if="item.Message" flat class="mt-0 pa-1">
                          <strong style="white-space:pre-wrap; word-wrap:break-word;">
                            {{item.Message}}
                          </strong>
                        </v-card>
                      </v-card-text>
                    </v-card>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>

          <div v-show="isShowCart" class="mt-3">
<!--
            {{Amount}} {{TotalFee}} {{selectedSamples.length}}
-->
<!--
            <span v-if="selectedSamples.length > 0" class="ml-2">{{selectedSamples.length}}サンプル 設定されています。</span>
            <span v-if="OpinionCount > 0" class="ml-2">内、{{OpinionCount}}サンプル がご相談を希望されています。</span>
            <v-tooltip top color="grey darken-1">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  rounded 
                  block 
                  color="amber darken-1" 
                  @click="validationQuote()"
                  data-createQuote>
                  <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  見積依頼{{modeText}}内容を確認する
                </v-btn>
              </template>
              <span>クリックすると、見積依頼{{modeText}}内容の確認画面が開きます</span>
            </v-tooltip>
-->
          </div>

      </v-col>

    </v-row>
<!--
    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
            ご依頼{{modeText}}内容をご確認ください
        </v-card-title>
        <v-card-text>
           下記のお見積り依頼内容をご確認のうえ「お見積りを依頼する」ボタンをクリックしてください<br>
           ※グレーの分析項目は分析セットに含まれる分析項目です。緑の分析項目は個別に追加された分析項目です。
         </v-card-text>

            <v-card outlined flat class="mb-3">
              <div class="teal darken-1 pa-2 mt-0 mb-1 white--text">お見積り依頼内容</div>
              <v-row class="pa-2 mt-0" dense>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>

                  <v-data-table
                    :headers="confirmSamplesHeaders"
                    :items="selectedSamples"
                    v-model="selectedSamples"
                    :sort-by="['SampleID']"
                    :sort-desc="[false]"
                    :page.sync="page"
                    :items-per-page=100
                    :loading="loading"
                    class="elevation-1"
                    loading-text="読込中"
                    no-data-text="分析依頼サンプルを追加して下さい。"
                    hide-default-footer
                    dense
                    :expanded="selectedSamples"
                    @page-count="pageCount = $event"
                    @input="$v.selectedSamples.$touch()"
                  >
                    <template v-slot:[`item.Status`]="{ item }">
                      <v-chip v-if="item.insert==true" small color="green" class="ml-2 mt-1 mb-1 white--text">追加</v-chip>
                      <v-chip v-if="item.update==true" small color="blue" class="ml-2 mt-1 mb-1 white--text">更新</v-chip>
                      <v-chip v-if="item.delete==true" small color="red" class="ml-2 mt-1 mb-1 white--text">削除</v-chip>
                    </template>
                    <template v-slot:[`item.OilTypeText`]="{ item }">
                      {{item.OilTypeCategoryText}}（{{ item.OilTypeText }}）
                    </template>
                    <template v-slot:[`item.AnalizeSetName`]="{ item }">
                      <div v-if="item.AnalizeSetName">{{item.AnalizeTypeGroupName}}／{{ item.AnalizeSetName }}</div>
                      <div v-else>{{item.AnalizeTypeGroupName}}（分析セット指定なし）</div>
                    </template>
                    <template v-slot:[`item.Options`]="{ item }">
                      <v-chip v-if="item.Opinion==true"   small label color="red" class="ml-2 mt-1 mb-1 white--text">{{ getOpinionString(item.Opinion) }}</v-chip>
                      <v-chip v-show="item.Filter!='001'" small outlined label class="ml-2 mt-1 mb-1" color="green darken-3">{{ getFilterString(item.Filter) }}</v-chip>
                      <v-chip v-show="item.Surplus!='0'"  small outlined label class="ml-2 mt-1 mb-1" color="green darken-3">{{ getSurplusString(item.Surplus) }}</v-chip>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-chip v-show="item.analizeItemListInclude" v-for="a of item.analizeItemListInclude" v-bind:key="a.Value" class="ml-4 mt-1 mb-1 black--text" small color="grey lighten-1">{{ a.Text }}</v-chip>
                        <v-chip v-show="item.AnalizeItemNames"    v-for="a of item.AnalizeItemNames"    v-bind:key="a.Value" class="ml-4 mt-1 mb-1 white--text" small color="green darken-3">{{ a.Text }}</v-chip>
                      </td>
                    </template>
                  </v-data-table>



                </v-col>
              </v-row>
          </v-card>

        <v-card-actions>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="isConfirmed = false"
          >
            キャンセル
          </v-btn>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn 
              v-on="on"
              rounded 
              color="amber darken-1" 
              @click="createQuote()" 
              :disabled="processing"
              data-createQuote 
              class="px-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  お見積りを依頼する
              </v-btn> 
            </template>
            <span>お見積依頼を登録します</span>
          </v-tooltip>


        </v-card-actions>
      </v-card>
    </v-dialog>
-->

  <!-- dialogコール -->
<!--
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
-->
    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
//import { createApplication,  } from "../graphql/mutations"
//import { updateApplication,  } from "../graphql/mutations"
//import { createSample } from "../graphql/mutations"
//import { updateSample } from "../graphql/mutations"
//import { deleteSample } from "../graphql/mutations"
import { getApplication, samplesByApplication } from '../graphql/queries'
//import { officeByCompany, } from '../graphql/queries'
//import { companyByKey, } from '../graphql/queries'
//import { sortedAnalizeSetByType, } from '../graphql/queries'
//import { sortedAnalizeItemByType, } from '../graphql/queries'
//import { analizeItemByCompany, } from '../graphql/queries'
//import { analizeTypeByGroup, } from '../graphql/queries'
//import { analizeTypeGroupByCategory, } from '../graphql/queries'
//import validations from '../utils/validations.js'
//import { required, maxLength } from 'vuelidate/lib/validators'
//import isFailured from "../components/failureDialog.vue"
//import valiErrored from "../components/validateErrorDialog.vue"
//import entSuccessed from "../components/successApplicationDialog_JXTG.vue"
//import { helpers } from 'vuelidate/lib/validators'
//import generateUuid  from '../utils/generateUuid.js'
//const alpha_dash = helpers.regex('alpha_dash', /^[a-zA-Z0-9_ -]*$/)
//const eneosOrderNumber = helpers.regex('eneosOrderNumber', /^[0-9]{2}[A-Z]{2}[0-9]{3,4}$/)
import mixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'

export default {
//  mixins:[validations, generateUuid, utilsMixin, utils],
  mixins:[mixin, utils],
  head: {
    title: { inner: '分析・診断サービス依頼'},
  },
  components: {
//    sucDialog: entSuccessed,
//    appDialog: isFailured,
//    valiDialog: valiErrored,
  },  
  data() {
    return {
      drawer: null,
      isShowCart: true,
      inputCols: 8,
      cartCols: 4,
      selectTab: "1",
      tabTitles: [
        {id: "1", name: '分析サンプルを追加する'},
        {id: "2", name: 'マイ機器から分析サンプル追加する'},
      ],
//      stepper1: 1,
//      stepper2: 1,

      isItemsInclude: false,  
//      analizeItemListInclude: [],
      overlayStepper1: false,

      AnalizeTypeCategory: "",

      analizeTypeGroupList: [],
      oilTypeCategoryList: [],

      analizeTypeList: [],
      analizeItemList: [],  // 該当分析区分の分析項目リスト
      analizeItemSubList: [],  // 該当分析区分の分析項目（サブ）リスト
      activeAnalizeItemList: [],  // 選択中のセットに含まれる項目を除いた分析リスト（依頼できる分析項目リスト）


      analizeSetItems: [], // セットに含まれる分析項目リスト
      analizeItemNames: [], // 選択中の個別分析項目の名称リスト

      OilTypeList:[],
      OilTypeCategory:"",
      OilTypeCategoryText:"",
      OilType: "",
      OilTypeText: "",
      HazardousMaterialsDetail: "",
      isHazardousMaterials: false,

      Filter: "001",
      Surplus: "0",
      isAccept: "1",

      analizeSetList: [],
      AnalizeItems: [],
      AnalizeItemSub: {},

      selectedSamples: [],

      AnalizeType: "",
      AnalizeTypeName: "",
      AnalizeTypeGroup: "",
      AnalizeSet: "",
      AnalizeSetName: "",

      SampleName: "",
      SampleMemo: "",
      SameCount: 1,

      Opinion: false,
      isOpinionDisabled: false,
      SampleMessage: "",

//      editid:"", //編集中サンプルのid
//      viewid:"", //表示中サンプルのid
//      doAddSample: false, //サンプル追加（更新）ボタンを押せるか
//      machines: [],
//      searchMachineKeyword: '',
//      machineListPage: 1,
//      machineListPageCount: 0,
//      machineListItemsPerPage: 10,
//      itemsPerPageList: [ 10,30,50 ],
/*
      machineListHeaders: [
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "teal darken-1 white--text",
          width: '30%'
        },
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "teal darken-1 white--text",
          width: '60%'
        },
        {
          text: '選択',
          value: 'id',
          class: "teal darken-1 white--text",
          width: '10%',
          sortable: false,
        },
      ],
      page: 0,
*/
//      MachineID: "0000000000",
//      CustomerMachineID: "",
//      MachineName: "",

//      OilmakerID: "",
//      OilModelNumber: "",
//      MakerID:"",
//      ModelNumber:"",

      Price: 0,
      Fee: 0,
      SetPrice: 0,
      Require:0,
      SetRequire:0,
      FilterFee:0,

      Amount:0,
      TotalFee: 0,
      OpinionCount: 0,
      AnsweredCount: 0,
      SurplusCount: 0,
      DiscountInfo: {},

      Ratio: 0,
      Rounding: 0,

      //注文番号どうする？
      CustomerOrderNumber: "",

      isPageMove: false,
      processing: false,
      showSearch: true,

      quoteid: "",
      ApplicationName:"",
      OrdererName:"",
      quote: {},

      applicationStatusMode: 1,

//ここより↑生き

      RepCompany: "",

      applicationDate: "",
      applicationDatePicker: false,
      loading: false,

      selectedOffice: "",
      selectedOfficeName: "",
      samples: [],
      SamplingAtPicker: false,

      officeList: [],

      invalidOilUsageTimeValue: false,
      isConfirmed: false,
      isCreate: true,

      successUrl: '/',
      successText: '分析依頼のお見積り依頼を登録しました。',
      valiErrorText: '依頼内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
      failureUrl: '/',

      editedIndex: -1,
      editedItem: {
        DeliveryPeriod: '',
      },      
//      agreement_url: process.env.VUE_APP_AGREE_URL,
      agreement_url: "https://www.japan-analysts.com/downloads/terms/"
    }
  },
  validations: {
  },
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    }
  },
  computed: {

    useUnits () {
      return this.$store.state.useUnits
    },
    returnPath() {
      if(this.$store.state.isStaff == true) {
        return { path: '/staffpage' }
      }else {
        return { path: '/' }
      }
    }
  },
  mounted: async function () {
    if(this.$store.state.isStaff) {
      this.applicationStatusMode = 2
    }else {
      this.applicationStatusMode = 1
    }
    this.initialize()
  },
  methods: {
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
    initialize: async function () {

      if (this.$route.query.id == undefined){
        this.isCreate = true
      }else {
        this.isCreate = false
        this.OpinionCount = 0
        this.OpinionCount = 0
        this.AnsweredCount = 0
        this.SurplusCount = 0
        this.quoteid = this.$route.query.id
        let application = await API.graphql(graphqlOperation(getApplication, {id: this.quoteid}))
        this.quote = application?.data?.getApplication
        this.ApplicationName = this.quote.Name
        this.TotalPrice = Number(this.quote.Price)
        this.TotalFee = Number(this.quote.Fee)
        this.OrdererName = this.quote.OrdererCompanyName + " " + this.quote.OrdererOfficeName + " " + this.quote.OrdererName

        if(this.quote.Discount) {
          this.DiscountInfo = JSON.parse(this.quote.Discount)
        }else {
          this.DiscountInfo = {code:"", discount:0 }
        }

        this.AnalizeTypeCategory = this.getApplicationAnalizeTypeCategory(this.quote)
        this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
        this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)
        
        // samplesByApplicationを使用してサンプルを取得
        let samples = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.quoteid, limit: 999}))
        //サンプルID（連番）でソート
        let _samples = samples.data.samplesByApplication.items

        _samples.sort(function(a,b){
            if(a.createdAt < b.createdAt) return -1;
            if(a.createdAt > b.createdAt) return 1;
            return 0;
        });
        this.selectedSamples = _samples

      for (const sample of this.selectedSamples) {

          this.AnalizeTypeGroup = sample.AnalizeTypeGroup
          await this.changeAnalizeTypeGroup()

          this.AnalizeType = sample.AnalizeType
          await this.changeAnalizeType()

          this.AnalizeSet = sample.AnalizeSet
          await this.changeAnalizeSet()

          this.AnalizeItems = JSON.parse(sample.AnalizeItems)
          sample["AnalizeItems"] = this.AnalizeItems
          await this.changeAnalizeItems(this.AnalizeItems)
          sample["AnalizeItemNames"] = JSON.parse(sample.AnalizeItemNames)

          let _AnalizeItemSub = "{}"
          if(sample.AnalizeItemSub != undefined) {
            _AnalizeItemSub = JSON.parse(sample.AnalizeItemSub)
            sample["AnalizeItemSub"] = _AnalizeItemSub
//            this.AnalizeItemSub = _AnalizeItemSub
          }

//          sample["analizeItemListInclude"] = this.analizeItemListInclude
//          sample["AnalizeItemsInclude"] = this.AnalizeItemsInclude
//          sample["analizeItemList"] = this.analizeItemList
          sample["analizeSetItems"] = this.analizeSetItems
          sample["analizeItemList"] = this.activeAnalizeItemList

          console.log("this.analizeItemSubList:", this.analizeItemSubList)
          console.log("_AnalizeItemSub:", _AnalizeItemSub)

          let allAnalizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, JSON.parse(_AnalizeItemSub), this.analizeItemList, this.analizeItemSubList)
//          let allAnalizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, _AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
          console.log("allAnalizeItemNames:", allAnalizeItemNames)
          sample["allAnalizeItemNames"] = allAnalizeItemNames

/*
          sample["insert"] = false
          sample["delete"] = false
          sample["update"] = false
*/
          sample["Opinion"] = this.toBoolean(sample.Opinion)

          // 相談サンプル件数
          if(sample["Opinion"]) {
            this.OpinionCount ++
          }

          // サンプル返却希望件数
          if(sample["Surplus"] == "1"){
            this.SurplusCount ++
          }

          // 相談回答済み件数
          if(sample["Status"] == "quoteReturn"){
            this.AnsweredCount ++
          }
        }
//        this.reset()
      }
    },

    changeAnalizeTypeGroup: async function() {
      this.isItemsInclude = false
      if(this.AnalizeTypeGroup != "") {
        const typeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
        this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
        this.AnalizeTypeGroupName = typeGroup[0].Text

        if(this.OilTypeCategory){
          this.AnalizeType = String(Number(typeGroup[0].Code) + Number(this.OilTypeCategory))
          await this.changeAnalizeType()
        }
      }
    },
    changeAnalizeType: async function () {
      this.isItemsInclude = false
      if(this.AnalizeType != "") {
        this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
        this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
        this.activeAnalizeItemList = this.analizeItemList
        this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

/*一旦削除
        const standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
        this.standardValueList = standardvaluelist[0].standardValues
*/
        this.AnalizeSet = ""
        this.AnalizeSetName = ""
        this.AnalizeItems = ""
        this.StandardValue = ""
        this.StandardValueName = ""
        this.Price = 0
        this.Fee = 0
        this.SetPrice = 0
        this.Require = 0
        this.SetRequire = 0

        const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
        this.AnalizeTypeName = AnalizeTypeName[0].Text
      }
    },
    changeAnalizeSet: async function () {
      this.isItemsInclude = false
      if (this.AnalizeSet) {
        this.AnalizeItems = []
        const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
        this.AnalizeSetName = AnalizeSetName[0].Text
        this.analizeSetItems = []
  //            this.includeItem()
        this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

        this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])

        this.SetPrice = AnalizeSetName[0].Price
        this.SetRequire = AnalizeSetName[0].Require
        this.Price = this.SetPrice
        this.Fee = this.SetPrice
        this.Require = this.SetRequire
      } else {
        this.activeAnalizeItemList = this.analizeItemList
        this.AnalizeSet = ""
        this.AnalizeSetName = ""

        this.Price = this.Price - this.SetPrice
        this.Fee = this.Fee - this.SetPrice
        this.Require = this.Require - this.SetRequire
        this.SetPrice = 0
        this.SetRequire = 0
//        this.AnalizeItemsInclude = []
//        this.analizeItemListInclude = []

        this.analizeSetItems = []
      }
      this.consolelogPrice()
      await this.changeAnalizeItems(this.AnalizeItems)
    },
    changeAnalizeItems: async function (selecteditems) {
      for (var parentItem of Object.keys(this.analizeItemSubList)) {
        if(selecteditems.includes(parentItem)) {
          // サブ項目がある分析項目がえらばれている場合は配列をセット（継続）
          let selectedSub = this.AnalizeItemSub[parentItem]
          if(selectedSub == undefined) {
            selectedSub = []
          }
          this.AnalizeItemSub[parentItem] = selectedSub
          }else {
            const includeSet = this.analizeSetItems.filter(item => item.Value  == parentItem)
            if(!includeSet[0]) {
              // サブ項目がある分析項目が選ばれていなかった且つ、セットにも含まれていない場合は削除（リセット）
              delete this.AnalizeItemSub[parentItem]
            }else {
              let selectedSub = this.AnalizeItemSub[parentItem]
              if(selectedSub == undefined) {
                selectedSub = []
              }
              this.$set(this.AnalizeItemSub, parentItem, selectedSub);
            }
          }
      }

      this.calcAnalizeItemPriceAll()
    },
    calcAnalizeItemPriceAll: function() {
      this.Price = this.SetPrice
      this.Fee = this.SetPrice
      this.Require = this.SetRequire

      for (var selecteditem of this.AnalizeItems) {
        let itemlist = this.analizeItemList.filter(item => item.Value  == selecteditem)
        this.calcAnalizeItemPrice(itemlist[0])
        this.Require = this.Require + Number(itemlist[0].Require)
      }

      if(this.analizeItemSub) {
        for (var parentItem of Object.keys(this.AnalizeItemSub)) {
            let _analizeItemSubList = this.analizeItemSubList[parentItem]
            for (var selecteditemsub of this.AnalizeItemSub[parentItem]) {
              let itemlist = _analizeItemSubList.filter(item => item.Value  == selecteditemsub)
              this.calcAnalizeItemPrice(itemlist[0])
              this.Require = this.Require + Number(itemlist[0].Require)
            }
          }
      }
    },
    calcAnalizeItemPrice: function(item) {
      let price = Number(item.Price)
      let fee = this.getAnalizeItemFee(item,this.Ratio,this.Rounding)
      let discount = price - fee

      this.Price = this.Price + price
      this.Fee = this.Fee + fee
      this.Discount = this.Discount + discount
      this.consolelogPrice()
    },

    consolelogPrice() {
/*
      let pricelog = {
        SetPrice: this.SetPrice,
        SetRequire: this.SetRequire,
        Price: this.Price,
        Fee: this.Fee,
        Require: this.Require,
        FilterFee: this.FilterFee,
        Discount: this.Discount,
      }
      console.log("price log", pricelog)
*/
    }
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
}
</script>
<style scoped>
.agree-text /deep/ label {
    color: black;
}
</style>
<style scoped>
.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: none !important;
  background-color:rgb(235, 232, 232)
}
.cart-list {
  overflow-y: auto;
}
.label-chip {
  margin-right : 10px;
  margin-bottom : 3px;
  width: 90px;
}</style>
